import { getRequestSingle } from '../services/requestHandler';
import { AppUser } from '../models';

export const getUserWithMyPlayers = async () => {
  const url = 'appuser/getUserWithMyPlayers?activeOnly=true&useCache=false';
  const response = await getRequestSingle<AppUser>('getUserWithMyPlayers', url);
  return response;
};
